import React from 'react';
import { useHistory } from 'react-router-dom';
import { AiOutlineCloudDownload, AiOutlineSolution } from 'react-icons/ai';
import { Button } from '@material-ui/core';

import './LoadButton.scss';

export default function LoadButton(props) {
  const { text, disabled, link, icon, style, onClick } = props;
  const history = useHistory();

  let Icon = ''
  switch (icon) {
    case 'excel':
      Icon = < AiOutlineSolution style={{ fontSize: 25, marginRight: 10 }} />;
      break;
    case 'load':
      Icon = <AiOutlineCloudDownload style={{ fontSize: 25, marginRight: 10 }} />;
      break;
    default: Icon = ''
  }

  const styleProps = style ? style : undefined

  return (
    <Button
      onClick={() => { onClick() }}
      className="LoadButton"
      variant="contained"
      disabled={disabled}
      style={styleProps}
    >
      {Icon}{text}
    </Button>
  );
}

